import axios from "axios";
import { toast } from "react-toastify";
export const GetAllSalaryPopulate = (data) => {
  return {
    type: "get_allsalariespopulate",
    payload: data,
    loader: false,
  };
};
export function getallSalaryPopulate() {
  return (dispatch) => {
    axios({
      url: `${process.env.REACT_APP_API_URL}Salaries/Populate`,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllSalaryPopulate(result.data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
export const GetAllSalaryTable = (data) => {
  return {
    type: "get_allsalariestable",
    payload: data,
    loader: false,
  };
};
export function getallSalaryTable() {
  return (dispatch) => {
    axios({
      url: `${process.env.REACT_APP_API_URL}Salaries/GetAll`,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllSalaryTable(result.data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
